// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__Arc6h","dragIcon":"Choice_dragIcon__O7pQS","left":"Choice_left__3FBXZ","input":"Choice_input__17Xqd"};